import { ListItem, Image, Text } from "@chakra-ui/react";
import Images from "./Images.jsx";

function CustomListItem({ children }) {
  return (
    <ListItem display="flex" alignItems="center">
      <Image mr=".5rem" src={Images.ListItemIcon} alt="" />
      <Text>{children}</Text>
    </ListItem>
  );
}

export default CustomListItem;
